import React, { useEffect, useState } from "react";
import AuthProvider from "../AuthProvider";
import Home from './Home'
import NavMenu from './NavMenu';
import { Button } from 'react-bootstrap';
import '../custom.css';
import Unauthorize from "./Unauthorize";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Dashboard from "./Landing_Page/Dashboard";
import TitleReport from "./Landing_Page/TitleReport";
import NotFound from "./Errors/NotFound"
import { apiHelper } from "./lib/ApiHelper";

function Login(props) {
    const [logURL, setLogURL] = useState('');
    const [userInitials, setUserInitials] = useState('');
    const [audience, setAudience] = useState(null);
    const [dashboardId, setDashboardId] = useState('');
    const [titleId, setTitleId] = useState('');
    const [username, setUserName] = useState('');
    const [DKAccordSetting, setDKAccordSetting] = useState([]);
    const [USAccordSetting, setUSAccordSetting] = useState([]);
    const [upn, setUpn] = useState('');
    const [isbnData, setIsbnData] = useState({
        listISBN: [],
        Loading: false,
        duplicates: [],
        invalid:[]
    }); 
    const [showNavMenu, setShowNavMenu] = useState(true);

    const location = useLocation();

    useEffect(() => {
        // Hide NavMenu if path is not found
      
        if (location.pathname === "/notfound") {
            setShowNavMenu(false);
        } else {
            setShowNavMenu(true);
        }
    }, [location]);

    const getCoverReports = async () => {
        try {
            const cvrDetails = await apiHelper.inventoryPostCall("getCoverReports", { value: props.profile.userPrincipalName });
            if (cvrDetails != undefined && cvrDetails != null) {
                setAudience(cvrDetails.audienceData?.audience ?? '');
                //setAudience('');
                // console.debug(cvrDetails.audienceData?.audience,"aud set");
                setLogURL(cvrDetails?.audienceData?.logourl ?? '');
                if (cvrDetails?.coverReports && cvrDetails?.coverReports.length > 0) {
                    setDashboardId(cvrDetails?.coverReports.find(i => i.reportName === "Dashboard")?.reportId ?? '');
                    setTitleId(cvrDetails?.coverReports.find(i => i.reportName === "Title Report")?.reportId ?? '');
                }
            } else {
                setAudience('');
            }
        } catch (error) {
            console.error("getCoverReports API erro", error);
        }
        //  console.debug(cvrDetails);
    }
    
        useEffect(() => {
            const savedUSSet = localStorage.getItem("UserSettingUS");
            let savedUS = [];
            if (savedUSSet) {
                try {
                    savedUS = JSON.parse(savedUSSet);
                } catch (err) {
                    savedUS = [];
                }
            }

            const savedDKSet = localStorage.getItem("UserSettingDK");
            let savedDK = [];
            if (savedDKSet) {
                try {
                    savedDK = JSON.parse(savedDKSet);
                } catch (err) {
                    savedDK = [];
                }
            }
            setDKAccordSetting(savedDK);
            setUSAccordSetting(savedUS);
        }, [])

  

    useEffect(() => {
        if (props.account) {
            setUserName(props.account.name);
        }
    }, [props.account]);

    useEffect(() => {
        if (props.profile) {
            setUpn(props.profile.userPrincipalName);
        }
    }, [props.profile]);

    useEffect(() => {
        if (props?.ADGroups != null && JSON.stringify(props.ADGroups).length > 0 && showNavMenu) {
            getCoverReports();
        }
    }, [props.ADGroups]);


    const isApiPath = (pathname) => {
        return pathname.startsWith('/api/');
    };
        return (
            <div>
                <section>
                    {(props.authorize != null && !props.authorize) ? (
                        <Unauthorize />
                    ) :
                        !props.account ? (
                            <>
                                <div className="login-box app-font">
                                    <div>
                                        <div className="login-logo">
                                            {/* <a href="#"><img src="https://www.penguinrandomhouse.com/wp-content/themes/penguinrandomhouse/images/prh-logo.png" alt="PRH-Catalog Search" /></a> */}
                                            Inventory Hub
                                        </div>
                                        <div className="login-box-body">
                                            <Button className="login-orange-button" onClick={props.onSignIn}>Sign in</Button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                                
                                <React.Fragment>
                                    {showNavMenu && <NavMenu setUserInitials={setUserInitials} audience={audience} username={username} logo={logURL} isbnData={isbnData} setIsbnData={setIsbnData} upn={upn} setUSAccordSetting={setUSAccordSetting} setDKAccordSetting={setDKAccordSetting} />}
                                     {/*   <NavMenu username={username} logo={logURL} isbnData={isbnData} setIsbnData={setIsbnData} upn={upn} />*/}
                                    <Routes>
                                        <Route path="/overview" element={<Home isbnData={isbnData} setIsbnData={setIsbnData} userInitials={userInitials} audience={audience} DKAccordSetting={DKAccordSetting} USAccordSetting={USAccordSetting} setUSAccordSetting={setUSAccordSetting} setDKAccordSetting={setDKAccordSetting } />} />
                                        <Route path="/" className="dboard" element={<Dashboard audience={audience} token={props.BiToken} reportId={dashboardId} isbnData={isbnData} setIsbnData={setIsbnData} upn={upn} />} />
                                            <Route path="/titleReport" className="dboard" element={<TitleReport reportId={titleId} token={props.BiToken} isbnData={isbnData} setIsbnData={setIsbnData} upn={upn} />} />
                                        {/*<Route path="*" element={<NotFound />} /> */}
                                        <Route path="*" element={isApiPath(location.pathname) ? <Navigate to="/notfound" /> : <NotFound />} />
                                        </Routes>
                                    </React.Fragment>
                          
                        )}
                    {props.error && (
                        <p className="error">Error: {props.error}</p>
                    )}
                </section>

            </div>
        );
}

export default AuthProvider(Login);
